import React from 'react';

// Renders the green/blue "Viewing: <X> · N facilities" strip with
// View facilities / Clear actions. Driven by the currentScope object
// produced by useCurrentScope.
//
// Returns null when scope.kind === 'none' so callers can render this
// unconditionally. Pages that want to hide the View facilities button
// (because they don't have a facility-detail modal yet) can pass
// `onViewFacilities={null}`.
//
// Cross-page "hop to another scoped report" lives in the left sidebar
// (activated outline + → on the active item), not here.
function ScopeBar({ scope, onViewFacilities, viewFacilitiesDisabled = false }) {
  if (!scope || scope.kind === 'none') return null;

  return (
    <div className={scope.bannerClass}>
      <div>
        <strong>{scope.viewingLabel}</strong> {scope.name}
        {scope.facilityCount > 0 && (
          <span className="scope-bar-meta">
            {' '}&middot; {scope.facilityCount} facilit{scope.facilityCount === 1 ? 'y' : 'ies'}
          </span>
        )}
      </div>
      <div className="scope-bar-actions">
        {onViewFacilities && (
          <button
            type="button"
            className="scope-bar-btn"
            onClick={onViewFacilities}
            disabled={viewFacilitiesDisabled}
            title={scope.clearTitle}
          >
            View facilities
          </button>
        )}
        {scope.clear && (
          <button
            type="button"
            className="scope-bar-btn"
            onClick={scope.clear}
          >
            {scope.clearLabel}
          </button>
        )}
      </div>
    </div>
  );
}

export default ScopeBar;
